import { isVODChannel } from 'shared/utils/channel-helpers';
import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { normalizeVideo } from 'shared/redux/helpers/normalized';
import { getChannelById } from '@wix/wix-vod-shared/dist/src/common/selectors/channels';
import {
  getChannelVideoById,
  getSingleVideoById,
} from 'api/public/channel-videos/channel-videos';
import { getYoutubeVideoById } from 'api/public/youtube/videos';
import { hydratedData } from 'services/hydrated-data';

const ACTIONS = createAsyncActions('SERVER.CHANNEL.VIDEO.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export const getPublicVideo = (channelId, videoId) => async (
  dispatch,
  getState,
) => {
  const state = getState();
  const params = { channelId, videoId };
  const channel = getChannelById(state, channelId);

  dispatch(START(params));

  let response;

  try {
    if (hydratedData.getSingleVideoId() === videoId) {
      response = await getSingleVideoById(channelId, videoId);
    } else if (channel) {
      response = isVODChannel(channel)
        ? await getChannelVideoById(channelId, videoId)
        : await getYoutubeVideoById(videoId);
    } else {
      try {
        response = await getChannelVideoById(channelId, videoId);
      } catch (error) {
        if (error.status === 404) {
          response = await getYoutubeVideoById(videoId);
        }
      }
    }

    response = {
      ...response,
      data: normalizeVideo(response.data),
    };

    dispatch(SUCCESS(params, response));
    return response;
  } catch (error) {
    dispatch(
      FAIL(params, error, {
        analytics: { type: 'error', name: 'shared.channel.video.get' },
      }),
    );
  }
};
